import { render, staticRenderFns } from "./ResultNav.vue?vue&type=template&id=8dd9c116&scoped=true&"
import script from "./ResultNav.vue?vue&type=script&lang=js&"
export * from "./ResultNav.vue?vue&type=script&lang=js&"
import style0 from "./ResultNav.vue?vue&type=style&index=0&id=8dd9c116&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd9c116",
  null
  
)

export default component.exports